'use strict';

import _ from 'lodash';

export default {
    keysToUpper: function( obj : { [ key : string ] : any } ) {
        const objectKeys = Object.keys( obj ) as string[];

        for ( const key of objectKeys ) {
            obj[ key.toUpperCase() ] = obj[ key ];
            delete obj[ key ];
        }

        return obj;
    },

    getDiffKeys( obj1 : { [ key : string ] : any }, obj2 : { [ key : string ] : any }, compareRaw : string[] = [], checkSubKeysFor : string[] = [], ignoreKeys : string[] = [], parentKey : string = '' ) : string[] {
        const obj1ComparedKeys : string[] = [];

        let retVal : string[] = [],
            objectKeys        = Object.keys( obj1 ?? {} ) as string[];

        for ( const key of objectKeys ) {
            let resultKey = key;

            if ( parentKey ) {
                resultKey = `${parentKey}.${key}`;
            }

            try {
                if (
                    !retVal.includes( resultKey )
                    && obj1[ key ] !== undefined
                ) {
                    const resultFnc = () => {
                        if ( !ignoreKeys.includes( resultKey ) ) {
                            retVal.push( resultKey );
                        }

                        if ( checkSubKeysFor.includes( resultKey ) && typeof obj1[ key ] === 'object' && obj2 && typeof obj2[ key ] === 'object' ) {
                            retVal = retVal.concat( this.getDiffKeys( obj1[ key ], obj2[ key ], compareRaw, checkSubKeysFor, ignoreKeys, resultKey ) );
                        }
                    };

                    obj1ComparedKeys.push( resultKey );

                    if ( obj2 === undefined || obj2[ key ] === undefined ) {
                        resultFnc();
                    }
                    else if ( compareRaw.includes( resultKey ) || typeof obj1[ key ] !== 'object' ) {
                        if ( obj1[ key ] !== obj2[ key ] ) {
                            resultFnc();
                        }
                    }
                    else if ( JSON.stringify( obj1[ key ] ) !== JSON.stringify( obj2[ key ] ) ) {
                        resultFnc();
                    }
                }
            }
            catch ( e ) {
                console.error( `Error occurred for key '${key}':`, e );
            }
        }

        objectKeys = Object.keys( obj2 ?? {} ) as string[];
        for ( const key of objectKeys ) {
            let resultKey = key;

            if ( parentKey ) {
                resultKey = `${parentKey}.${key}`;
            }

            if (
                !obj1ComparedKeys.includes( resultKey )
                && !retVal.includes( resultKey )
                && obj2[ key ] !== undefined
            ) {
                const resultFnc = () => {
                    if ( !ignoreKeys.includes( resultKey ) ) {
                        retVal.push( resultKey );
                    }

                    if ( checkSubKeysFor.includes( resultKey ) && typeof obj2[ key ] === 'object' && obj1 && typeof obj1[ key ] === 'object' ) {
                        retVal = retVal.concat( this.getDiffKeys( obj2[ key ], obj1[ key ], compareRaw, checkSubKeysFor, ignoreKeys, resultKey ) );
                    }
                };

                if ( obj1 === undefined || obj1[ key ] === undefined ) {
                    resultFnc();
                }
                else if ( compareRaw.includes( resultKey ) || typeof obj2[ key ] !== 'object' ) {
                    if ( obj1[ key ] !== obj2[ key ] ) {
                        resultFnc();
                    }
                }
                else if ( JSON.stringify( obj1[ key ] ) !== JSON.stringify( obj2[ key ] ) ) {
                    resultFnc();
                }
            }
        }

        // unique
        const uniqueKeys = [] as string[];
        for ( let i = retVal.length - 1; i >= 0; i-- ) {
            if ( !uniqueKeys.includes( retVal[ i ] ) ) {
                uniqueKeys.push( retVal[ i ] );
            }
            else {
                retVal.splice( i, 1 );
            }
        }

        return retVal;
    },

    getMissingKeys( obj1 : { [ key : string ] : any }, obj2 : { [ key : string ] : any }, checkSubKeysFor : string[] = [], ignoreKeys : string[] = [], parentKey : string = '' ) : string[] {
        let retVal : string[] = [],
            objectKeys        = Object.keys( obj1 ?? {} ) as string[];

        for ( const key of objectKeys ) {
            if (
                !retVal.includes( key )
                && obj1[ key ] !== undefined
                && (
                    obj2 === undefined
                    || obj2[ key ] === undefined
                )
            ) {
                let resultKey = key;
                if ( parentKey ) {
                    resultKey = `${parentKey}.${key}`
                }

                if ( !ignoreKeys.includes( resultKey ) ) {
                    retVal.push( resultKey );
                }

                if ( checkSubKeysFor.includes( resultKey ) && _.isObject( obj1[ key ] ) && obj2 && _.isObject( obj2[ key ] ) ) {
                    retVal = retVal.concat( this.getMissingKeys( obj1[ key ], obj2[ key ], checkSubKeysFor, ignoreKeys, resultKey ) )
                }
            }
        }

        objectKeys = Object.keys( obj2 ?? {} ) as string[];
        for ( const key of objectKeys ) {
            if (
                !retVal.includes( key )
                && obj2[ key ] !== undefined
                && (
                    obj1 === undefined
                    || obj1[ key ] === undefined
                )
            ) {
                let resultKey = key;
                if ( parentKey ) {
                    resultKey = `${parentKey}.${key}`
                }

                if ( !ignoreKeys.includes( resultKey ) ) {
                    retVal.push( resultKey );
                }

                if ( checkSubKeysFor.includes( resultKey ) && _.isObject( obj2[ key ] ) && obj1 && _.isObject( obj1[ key ] ) ) {
                    retVal = retVal.concat( this.getMissingKeys( obj2[ key ], obj1[ key ], checkSubKeysFor, ignoreKeys, resultKey ) )
                }
            }
        }

        // unique
        const uniqueKeys = [] as string[];
        for ( let i = retVal.length - 1; i >= 0; i-- ) {
            if ( !uniqueKeys.includes( retVal[ i ] ) ) {
                uniqueKeys.push( retVal[ i ] );
            }
            else {
                retVal.splice( i, 1 );
            }
        }

        return retVal;
    }
};
